import React from "react";
import { useNavigate } from "react-router";
import styles from "./Home.module.css";
import { CiHeart } from "react-icons/ci";
import { IoIosArrowRoundForward } from "react-icons/io";
import { ButtonOrange } from "../../components/Button";
import { ButtonWhite } from "../../components/Button";

function JoinOurMission() {
  const navigate = useNavigate();
  return (
    <div className={styles.joinOurMission}>
      <div className={styles.titleText}>
        <p>Join Our Mission</p>
      </div>
      <div className={styles.descriptionText}>
        <p>
          Your support helps us continue providing vital services to
          Mississippi's roadworkers. Every contribution makes a difference in
          the lives of the people who keep our roads safe and accessible.
        </p>
      </div>
      <div className={styles.joinUsButtons}>
        <ButtonOrange onClick={() => navigate("/donate")}>
          Make a Donation <CiHeart />
        </ButtonOrange>
        <ButtonWhite onClick={() => navigate("/contact")}>
          Get in Touch <IoIosArrowRoundForward />
        </ButtonWhite>
      </div>
    </div>
  );
}

export default JoinOurMission;
